import React from "react";

type Props = {
	pages: number;
	currentPage: number;
	handlePageChange: (page: number) => void;
	handleNextPage: () => void;
};

const scrollToTop = () => {
	setTimeout(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, 100);
};

const PageNumbers = ({ pages, currentPage, handlePageChange, handleNextPage }: Props) => {
	return (
		<div className="to-lg:mt-24 my-[6.25rem] flex justify-between">
			{pages > 1 && (
				<div className="flex flex-row gap-1">
					{Array.from(Array(pages).keys()).map((page, i) => {
						return (
							<button
								key={i}
								className={`${
									page + 1 === currentPage
										? "h-9 w-9 bg-navy text-beige rounded-full"
										: "h-9 w-9 bg-transparent text-navy border-3 border-navy rounded-full"
								}`}
								onClick={() => {
									handlePageChange(page + 1);
									scrollToTop();
								}}>
								{page + 1}
							</button>
						);
					})}
				</div>
			)}
			{pages > 1 && (
				<button
					className="tag-pill border-3 disabled:opacity-50 disabled:cursor-not-allowed"
					disabled={pages === currentPage}
					onClick={() => {
						handleNextPage();
						scrollToTop();
					}}>
					Next page
				</button>
			)}
		</div>
	);
};

export default PageNumbers;
